import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "d-grid gap-2" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = {
  version: "1.2",
  style: {"overflow":"visible","width":"299px","height":"1px","opacity":"1","mix-blend-mode":"normal","rotate":"0deg"}
}
const _hoisted_8 = { class: "d-flex search-buttons mx-auto" }

import SearchFormContent from '@/components/UserRoles/SearchFormContent.vue';
import { userRoleSearchFormType } from "@/types/requests/userRoleSearchForm"
import UserRoleService from "@/services/models/UserRole";
import SelectRoleChecker from '@/router/selectRoleChecker'
import { OPERATION_OFFICE, DEPARTMENT } from "@/services/consts/user_role";
import { Ref, ref, computed, watch } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForm',
  props: {
    isLoading: { type: Boolean },
    errors: {}
  },
  emits: [
    'search',
    'setErrors',
    'clear'
],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit
const hide: Ref<boolean> = ref(false)
const form = ref({} as userRoleSearchFormType)
const searchFormContent = ref()

const unwatchOrganization = watch(
  () => form.value.organization,
  () => {
    const current_role = SelectRoleChecker.getCurrentRole()
    if(current_role && current_role.organization_type == OPERATION_OFFICE.type){
      emits('search', form.value)
    }
    unwatchOrganization();
  },
  {flush: 'post'}
);

const unwatchDepartment = watch(
  () => form.value.department,
  () => {
    const current_role = SelectRoleChecker.getCurrentRole()
    if(current_role && current_role.organization_type == DEPARTMENT.type){
      emits('search', form.value)
    }
    unwatchDepartment();
  },
  {flush: 'post'}
);

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})

const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})

function clearForm () {
  form.value = {
    organization: { id: null, type: "", name: "", departments: []},
    department: { id: null,operation_office_id: null, name: ""},
    display_name: ""
  }
  searchFormContent.value.resetOfficeableType()
  clearErrors()
  searchFormContent.value.clearSessionStorage('userRolesSearchFormContent')
  emits('clear')
}

const changeSearchButton = computed(() => {
  return props.isLoading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec')
})

function handleClickSearch() {
  clearErrors()
  if (validateForm(form.value)) {
    emits('search', form.value)
    searchFormContent.value.saveFormValuesToSessionStorage()
  }
}

function validateForm(form: userRoleSearchFormType) {
  let ret = true
  const errors = UserRoleService.validateSearchForm(form)

  if(errors.organization.length > 0) {
    ret = false
  }
  if(errors.department.length > 0) {
    ret = false
  }
  if(errors.display_name.length > 0) {
    ret = false
  }
  if(!ret) {
    emits('setErrors', errors)
  }

  return ret
}

function toggleSidebar () {
  hide.value = !hide.value
}

function clearErrors() {
  const errors = {
    organization: [],
    department: [],
    display_name: []
  }
  emits('setErrors', errors)
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : '' }`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SearchFormContent, {
          ref_key: "searchFormContent",
          ref: searchFormContent,
          modelValue: form.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form).value = $event)),
          errors: __props.errors
        }, null, 8, ["modelValue", "errors"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("defs", null, [
              _createElementVNode("path", {
                id: "path-1650848226989195",
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1),
            _createElementVNode("g", { transform: "translate(-1126, -703)" }, [
              _createElementVNode("path", {
                style: {"stroke":"rgb(194, 186, 186)","stroke-width":"1","stroke-linecap":"butt","stroke-linejoin":"miter","fill":"none"},
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1)
          ]))]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_btn, {
            class: "ma-2 exec-btn",
            onClick: handleClickSearch,
            disabled: props.isLoading,
            style: _normalizeStyle({
              backgroundColor : props.isLoading ? '#B3B8BB' : ''
            })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(changeSearchButton.value), 1)
            ]),
            _: 1
          }, 8, ["disabled", "style"]),
          _createVNode(_component_v_btn, {
            class: "ma-2 reset-btn",
            disabled: props.isLoading,
            onClick: clearForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], 2)
  ], 2))
}
}

})